import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { tap } from "rxjs";
import { UserHof } from "../models/userHof.model";
import { HallOfFameService } from "../services/hall-of-fame.service";
import { GetHofAction, GetSiteHoFAction } from "./hof.actions";
import { SiteHoF } from "../models/siteHoF.model";
import { NamePipe } from "../../user-profile/pipe/name.pipe";

export interface HofStateModel {
  scores: UserHof[];
  scoresSite: SiteHoF[];
}

@State<HofStateModel>({
  name: "HofStore",
  defaults: {
    scores: [],
    scoresSite: [],
  },
})
@Injectable()
export class HofState {
  constructor(private service: HallOfFameService) {}

  @Selector()
  static selectScores(state: HofStateModel) {
    return state.scores;
  }

  @Selector()
  static selectScoresSite(state: HofStateModel) {
    return state.scoresSite;
  }

  /**
   * State action to get scores
   * @param ctx StateContext<HofState>
   * @returns all scores
   */
  @Action(GetHofAction)
  getHofAction(ctx: StateContext<HofStateModel>) {
    return this.service.getHallOfFame().pipe(
      tap((res) => {
        const state = ctx.getState();
        ctx.setState({
          ...state,
          scores: res.map((hof) => {
            hof.name = new NamePipe().transform(hof.email, "name");
            hof.surname = new NamePipe().transform(hof.email, "surname");
            return hof;
          }),
        });
      }),
    );
  }

  /**
   * State action to get scores by site
   * @param ctx StateContext<HofState>
   * @returns all site scores
   */
  @Action(GetSiteHoFAction)
  getSiteHofAction(ctx: StateContext<HofStateModel>) {
    return this.service.getSiteHallOfFame().pipe(
      tap((res) => {
        const state = ctx.getState();
        const scoresSite: SiteHoF[] = res ?? [];
        ctx.setState({
          ...state,
          scoresSite: scoresSite.sort(
            (a: SiteHoF, b: SiteHoF) => b.avg_score - a.avg_score,
          ),
        });
      }),
    );
  }
}
